var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 0C15.5854 0 18.0366 0.89697 20.1707 2.55758C22.3049 4.20485 24.122 6.61818 25.4268 9.63636C25.5244 9.86545 25.5244 10.1333 25.4268 10.3515C22.8171 16.3879 18.1707 20 13 20H12.9878C7.82927 20 3.18293 16.3879 0.573171 10.3515C0.47561 10.1333 0.47561 9.86545 0.573171 9.63636C3.18293 3.59879 7.82927 0 12.9878 0H13ZM13 5.15152C10.3049 5.15152 8.12195 7.32121 8.12195 10C8.12195 12.6667 10.3049 14.8364 13 14.8364C15.6829 14.8364 17.8659 12.6667 17.8659 10C17.8659 7.32121 15.6829 5.15152 13 5.15152Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0385 9.99612C16.0385 11.6567 14.6726 13.0143 13.0019 13.0143C11.319 13.0143 9.95312 11.6567 9.95312 9.99612C9.95312 9.79006 9.97752 9.59734 10.0141 9.4034H10.0751C11.4287 9.4034 12.5263 8.33673 12.5751 7.00218C12.7092 6.97915 12.8556 6.96582 13.0019 6.96582C14.6726 6.96582 16.0385 8.3234 16.0385 9.99612Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.66e3380b3f4f4ffa12140a9b3b090031.svg";
export { ForwardRef as ReactComponent };